import type { AuthTokens, TokenStorage } from "../types/auth.types";

type StoredAuthTokens = {
    accessToken?: unknown;
    refreshToken?: unknown;
};

type LocalStorageTokenStorage = TokenStorage & {
    saveAccessToken: (accessToken: string) => void;
    getAccessToken: () => string | null;
};

export const createLocalStorageTokenStorage = (
    key = "ecommerce_auth_tokens",
): LocalStorageTokenStorage => {
    const read = (): StoredAuthTokens | null => {
        const raw = localStorage.getItem(key);
        if (!raw) return null;

        try {
            return JSON.parse(raw) as StoredAuthTokens;
        } catch {
            localStorage.removeItem(key);
            return null;
        }
    };

    return {
        save: (tokens: AuthTokens) => {
            localStorage.setItem(key, JSON.stringify(tokens));
        },
        get: () => {
            const stored = read();
            return typeof stored?.accessToken === "string" &&
                typeof stored.refreshToken === "string"
                ? {
                      accessToken: stored.accessToken,
                      refreshToken: stored.refreshToken,
                  }
                : null;
        },
        saveAccessToken: (accessToken: string) => {
            localStorage.setItem(key, JSON.stringify({ accessToken }));
        },
        getAccessToken: () => {
            const stored = read();
            return typeof stored?.accessToken === "string" ? stored.accessToken : null;
        },
        clear: () => {
            localStorage.removeItem(key);
        },
    };
};
